// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"780":"30cb94b2","801":"4feabad2"}[chunkId] + ".chunk.css");